import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import HeroUnit from 'components/career/hero-unit'
import OurValues from 'components/career/our-values'
import Video from 'components/career/video'
import OpenPositions from 'components/career/open-positions'
import GetStarted from 'components/get-started'

const CareerStyle = styled.div``

export default class Carreer extends PureComponent {
  static propTypes = {
    heroUnit: PropTypes.shape({
      heading: PropTypes.string.isRequired,
      image: PropTypes.shape({
        publicURL: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    video: PropTypes.string.isRequired,
    openPositions: PropTypes.shape({
      heading: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          link: PropTypes.string.isRequired
        })
      )
    }).isRequired,
    getStarted: PropTypes.shape({
      heading: PropTypes.string.isRequired,
      button: PropTypes.shape({
        text: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  }

  render () {
    const { heroUnit, ourValues, video, openPositions, getStarted } = this.props
    return (
      <CareerStyle>
        <HeroUnit data={heroUnit} />
        <OurValues data={ourValues} />
        <Video data={video} />
        <OpenPositions data={openPositions} />
        <GetStarted data={getStarted} />
      </CareerStyle>
    )
  }
}
